module.exports = __webpack_public_path__ + "img/slider3.4b1e7bca.gif";